import React from 'react';
import { Badge } from '../../../../components/badge';
import { RoccoLink } from '../../../../components/link/RoccoLink';

interface UserMenuElementProps {
    title: string;
    icon?: React.ReactNode;
    to?: string;
    /** The link is not a Remix route. */
    external?: boolean;
    badgeCount?: number;
    onClick?: () => void;
}

/**
 * Link for the desktop user menu.
 */
export const UserMenuElement = ({
    title,
    icon,
    to,
    external = false,
    badgeCount = 0,
    onClick,
}: UserMenuElementProps) => {
    return (
        <div>
            <RoccoLink
                className="flex min-h-8 items-center justify-between px-2 py-1.5 text-gray-900 hover:text-gray-900 hover:opacity-70"
                to={to || '#'}
                prefetch="intent"
                role={onClick ? 'button' : 'link'}
                isNonRemixRoute={external}
                onClick={(e) => {
                    if (onClick) {
                        e.preventDefault();
                        onClick();
                    }
                }}
            >
                <span className="flex items-center gap-x-2">
                    <span className="flex size-4.5 shrink-0 items-center justify-start">
                        {icon}
                    </span>
                    <span className="line-clamp-2 text-sm">{title}</span>
                </span>
                {badgeCount > 0 && (
                    <Badge
                        size="centeredCompact"
                        text={badgeCount > 9 ? 'small' : 'default'}
                        // The header's counts are black, not brick.
                        className="bg-[#181818] text-white"
                    >
                        {badgeCount > 9 ? '9+' : badgeCount}
                    </Badge>
                )}
            </RoccoLink>
        </div>
    );
};
